import { canAnimateAuto, DisposalSet, onReady, select, selectAll } from '@neptune/cx/utils';

import '@splidejs/splide/css/core';

import './theme/tokens.scss';
import './theme/breakpoints.scss'
import './theme/typography.scss';
import './theme/global.scss';

import './overrides/alerts.scss';
import './overrides/btn.scss';
import './overrides/option-inputs.scss';
import './overrides/tabs.scss';
import './overrides/text-inputs.scss';
import './overrides/modules.scss';
import './overrides/pagination.scss';

import './fragments/util/npt-collection-config';
import './fragments/util/npt-conditional-content';
import './fragments/util/npt-segmented-content';

import './fragments/basics/cbdce-accordion';
import './fragments/basics/cbdce-accordion-set';
import './fragments/basics/cbdce-border-line';
import './fragments/basics/cbdce-button';
import './fragments/basics/cbdce-button-group';
import './fragments/basics/cbdce-heading';
import './fragments/basics/cbdce-highlight-link';
import './fragments/basics/cbdce-body-text';
import './fragments/basics/cbdce-social-icon';
import './fragments/basics/cbdce-social-icon-set';
import './fragments/basics/cbdce-testimonial';
import './fragments/basics/cbdce-text-button';

import './fragments/cards/cbdce-account-card';
import './fragments/cards/cbdce-card-slider';
import './fragments/cards/cbdce-featured-news-block';
import './fragments/cards/cbdce-file-link-card';
import './fragments/cards/cbdce-highlight-card';
import './fragments/cards/cbdce-news-item-card';
import './fragments/cards/cbdce-newsletter-card';
import './fragments/cards/cbdce-result-card';

import './fragments/content/cbdce-account-welcome';
import './fragments/content/cbdce-article-content';
import './fragments/content/cbdce-article-header';
import './fragments/content/cbdce-separator-word';

import './fragments/layouts/cbdce-2-col-layout';
import './fragments/layouts/cbdce-alphabet-tabs';
import './fragments/layouts/cbdce-container';
import './fragments/layouts/cbdce-content-backsplash';
import './fragments/layouts/cbdce-content-wrap';
import './fragments/layouts/cbdce-flex-content';
import './fragments/layouts/cbdce-page-narrow-content';
import './fragments/layouts/cbdce-search-layout';
import './fragments/layouts/cbdce-sidebar-tabs-container';
import './fragments/layouts/cbdce-spacer';

import './fragments/shell/cbdce-footer';
import './fragments/shell/cbdce-header';
import './fragments/shell/cbdce-profile-selection-menu';

import './components/cbdce-search-results';
import './portlets/cbdce-certificate-validation-portlet';
import './portlets/cbdce-edit-member-public-profile-portlet';
import './portlets/cbdce-education-hours-entry-portlet';
import './portlets/cbdce-view-member-public-profile-portlet';

import './widgets/cbdce-type-facet';

onReady(() => {
    const styleRoot = select<HTMLElement>(':root');
    styleRoot.classList.toggle('cbdce--can-animate-auto', canAnimateAuto);
    selectAll<HTMLAnchorElement>('a[href*="/o/saml/auth"]').forEach(a => {

        a.setAttribute('data-senna-off', 'true');
        const u = new URL(a.getAttribute('href') ?? '', location.origin);
        const ret = location.origin + location.pathname + location.search + location.hash;
        u.searchParams.set('_com_liferay_login_web_portlet_LoginPortlet_redirect', ret);
        a.href = u.toString();
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
}
